module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "range",
    class: {
      range_scale: _vm.showScale
    },
    on: {
      "click": _vm.wrapClick
    }
  }, [_c('div', {
    ref: "bar",
    staticClass: "range__bar"
  }, [_c('div', {
    ref: "slider",
    staticClass: "range__slider",
    class: {
      range__slider_error: _vm.error
    },
    style: (_vm.sliderStyle),
    on: {
      "mousedown": _vm.moveStart,
      "touchstart": _vm.moveStart
    }
  }), _c('div', {
    staticClass: "range__progress",
    class: {
      range__progress_error: _vm.error
    },
    style: (_vm.progressStyle)
  })]), (_vm.showScale) ? _c('div', {
    staticClass: "range__scale"
  }, _vm._l((_vm.scale), function(item) {
    return _c('div', {
      key: item,
      staticClass: "range__markup"
    }, [_c('span', {
      staticClass: "range__num"
    }, [_vm._v(_vm._s(item))])])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f5330b3","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/formrange/components/Range.vue
// module id = dff9c97fd608553bd4ed
// module chunks = 5